import GTMInstall from "../../../../contents/docs/integrate/_snippets/install-gtm.mdx";
import * as React from 'react';
export default {
  GTMInstall,
  React
};